import { render, staticRenderFns } from "./IndexBdc.vue?vue&type=template&id=0d808467&scoped=true&"
import script from "./IndexBdc.vue?vue&type=script&lang=js&"
export * from "./IndexBdc.vue?vue&type=script&lang=js&"
import style0 from "./IndexBdc.vue?vue&type=style&index=0&id=0d808467&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d808467",
  null
  
)

export default component.exports